//Live chat trigger
document.addEventListener('click', function(event) {
//ID trigger name
  const trigger = event.target.closest('a[href="#open-live-chat"]');

  if (!trigger) return;

  event.preventDefault();

  if (window.LiveChatWidget) {
    LiveChatWidget.call('maximize');
  } else {
    console.warn('LiveChat widget not loaded yet.');
  }
});